(function(){
function init(w){
var v=w.querySelector('.ovm-v'),k=w.querySelector('.ovm-k');
if(!v||!k||w.dataset.on)return;w.dataset.on='1';
var still=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var pos=0,paused=false,resume=0,drag=false,sx=0,sl=0,moved=0;
function half(){return k.scrollWidth/2}
function hold(ms){paused=true;clearTimeout(resume);resume=setTimeout(function(){if(!drag&&!w.matches(':hover'))paused=false},ms)}
w.addEventListener('mouseenter',function(){paused=true});
w.addEventListener('mouseleave',function(){if(!drag)hold(600)});
v.addEventListener('touchstart',function(){paused=true;clearTimeout(resume)},{passive:true});
v.addEventListener('touchend',function(){hold(2500)},{passive:true});
v.addEventListener('wheel',function(){hold(2500)},{passive:true});
v.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button!==0)return;drag=true;moved=0;sx=e.clientX;sl=v.scrollLeft;paused=true});
window.addEventListener('pointermove',function(e){if(!drag)return;var d=e.clientX-sx;moved=Math.max(moved,Math.abs(d));if(moved>4)v.classList.add('is-drag');v.scrollLeft=sl-d});
window.addEventListener('pointerup',function(){if(!drag)return;drag=false;v.classList.remove('is-drag');hold(2500)});
function go(dir){hold(3000);v.scrollBy({left:dir*(v.clientWidth*0.8),behavior:'smooth'})}
w.querySelector('.ovm-p').addEventListener('click',function(){go(-1)});
w.querySelector('.ovm-n').addEventListener('click',function(){go(1)});
function loop(){
var h=half();
if(h>0){
if(!paused&&!still){pos+=0.7;if(pos>=h)pos-=h;v.scrollLeft=pos}
else{
pos=v.scrollLeft;
if(pos>=h){pos-=h;v.scrollLeft=pos}
else if(pos<=0){pos=h-1;v.scrollLeft=pos}
}
}
requestAnimationFrame(loop)}
v.scrollLeft=1;pos=1;requestAnimationFrame(loop);
}
function all(){document.querySelectorAll('.ovm-w').forEach(init)}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',all);else all();
})();
